module.exports = __webpack_public_path__ + "img/virtual-reality.231cf663.jpg";